<template>
    <div id="webform">
        <div class="container mt-5 mb-5" v-if="loaded && !displayThanks">
            <div class="logo" v-if="!disabled">
                <v-img height="100px" position="left" contain :src="logo.doc_url"></v-img>
            </div>

            <div class="mt-4 text-center" v-if="!disabled">
                <h3>{{ providerData.name }}</h3>
                <h5 class="info-title">Mise à jour des informations de votre agence</h5>
            </div>

            <v-alert type="info"
                     v-if="!disabled"
                     text
                     class="mt-5 mb-5 form-container mr-auto ml-auto"
                     border="right"
                     colored-border>
                <div>
                    <p>Auvergne-Rhône-Alpes Tourisme, aux côtés de votre ADT et de votre OT vous accompagne dans la
                        promotion et la commercialisation de votre agence et vos offres. Nous vous invitons à mettre à
                        jour la fiche de votre agence réceptive. Afin d’illustrer votre savoir faire et de faciliter
                        le parcours des acheteurs professionnels et la prise de contact, nous vous invitons à renseigner
                        3 séjours pour une cible BtoB <i>(un best of, un spécialisé ou un groupe, un moins connu, par
                            exemple)</i>.</p>

                    <p>Vos offres seront ensuite critérisées selon les données que vous aurez renseignées
                        et promues auprès des Tour-opérateurs France et étrangers <i>(workshops, démarchage,
                            sollicitations spontanées ...)</i>, sur le site BtoB régional,
                        <a target="_blank" href='https://www.inauvergnerhonealpes.com'>www.inauvergnerhonealpes.com</a> en français et en
                        anglais, ainsi que sur les sites commerciaux départementaux et locaux, si cela correspond à
                        vos axes prioritaires de communication, bien entendu. </p>

                    <p>La durée de saisie est d’environ 20 minutes.</p>

                    <p>Nous vous conseillons de balayer les champs demandés avant de commencer la saisie de
                        vos informations. Un retour sur le questionnaire est toutefois possible via le bouton
                        « enregistrer ».</p>

                    <p>Si vous avez déjà procédé à la mise à jour de vos offres pour 2022 via votre collaboration Apidae
                        avec votre OT ou ADT, merci de ne pas tenir compte de ce message.</p>

                    <p>Nous vous remercions d’avance pour vos réponses,</p>

                    <p>L’équipe d’Auvergne-Rhône-Alpes Tourisme</p>
                </div>
            </v-alert>

            <div style="padding-top: 30px">
                <div class="tabulation-title">
                    <h5>
                        <v-icon>label_outline</v-icon> Informations générales
                    </h5>
                </div>

                <div class="form-container mr-auto ml-auto mt-5">
                    <v-text-field
                        v-model="providerData.name"
                        label="Intitulé/Identité de votre agence réceptive"
                        autocomplete="new-offer-name"
                        outlined>
                    </v-text-field>

                    <table>
                        <tr>
                            <td>
                                <v-label>Agence réceptive / DMC</v-label>
                            </td>
                            <td>
                                <v-radio-group row class="mt-auto mb-auto ml-5"
                                               v-model="providerData.receptiveAgency">
                                    <v-radio
                                        class="mr-5"
                                        label="Oui"
                                        :value="true"
                                        outlined>
                                    </v-radio>

                                    <v-radio
                                        label="Non"
                                        :value="false"
                                        outlined>
                                    </v-radio>
                                </v-radio-group>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <v-label>Cible</v-label>
                            </td>
                            <td>
                                <v-radio-group row class="mt-auto mb-auto ml-5"
                                               v-model="providerData.target">
                                    <v-radio
                                        class="mr-5"
                                        label="BtoB"
                                        :value="6484"
                                        outlined>
                                    </v-radio>

                                    <v-radio
                                        class="mr-5"
                                        label="BtoC"
                                        :value="6485"
                                        outlined>
                                    </v-radio>

                                    <v-radio
                                        class="mr-5"
                                        label="BtoB et BtoC"
                                        :value="6486"
                                        outlined>
                                    </v-radio>
                                </v-radio-group>
                            </td>
                        </tr>
                        <tr>
                            <td>
                                <v-label>Commercialisation à l'international</v-label>
                            </td>
                            <td>
                                <v-radio-group row class="mt-auto mb-auto ml-5"
                                               v-model="providerData.internationalExporation">
                                    <v-radio
                                        class="mr-5"
                                        label="Oui"
                                        :value="true"
                                        outlined>
                                    </v-radio>

                                    <v-radio
                                        class="mr-5"
                                        label="Non"
                                        :value="false"
                                        outlined>
                                    </v-radio>
                                </v-radio-group>
                            </td>
                        </tr>
                    </table>

                    <v-text-field
                        class="mt-5"
                        v-model="providerData.atoutFrance"
                        label="Numéro d'immatriculation Atout France"
                        outlined>
                    </v-text-field>

                    <v-autocomplete
                        chips
                        deletable-chips
                        :items="languages"
                        v-model="providerData.languages"
                        label="Langues parlées"
                        class="mt-5"
                        item-text="label"
                        item-value="apidae_element_id"
                        multiple
                        outlined>
                    </v-autocomplete>
                </div>

                <div class="tabulation-title">
                    <h5>
                        <v-icon>label_outline</v-icon> Descriptifs
                    </h5>
                </div>

                <v-alert type="info"
                         text
                         v-if="!disabled"
                         class="mt-5 mb-5 form-container mr-auto ml-auto"
                         border="right"
                         colored-border>
                    <div>Ces informations s'adressent à une cible professionnelle BtoB</div>
                </v-alert>

                <div class="form-container mr-auto ml-auto mt-5" >
                    <v-textarea
                        class="textarea mt-5"
                        counter
                        maxlength="255"
                        v-model="providerData.shortDescriptionFr"
                        outlined>
                        <template v-slot:label>
                            Descriptif court de votre agence <img :src="'/images/flags/fr.png'" height="20px">
                        </template>
                    </v-textarea>

                    <v-textarea
                        class="textarea mt-5"
                        counter
                        maxlength="255"
                        v-model="providerData.shortDescriptionEn"
                        outlined>
                        <template v-slot:label>
                            Descriptif court de votre agence <img :src="'/images/flags/en.png'" height="20px">
                        </template>
                    </v-textarea>

                    <v-textarea
                        class="textarea mt-5"
                        v-model="providerData.longDescriptionFr"
                        outlined>
                        <template v-slot:label>
                            Descriptif détaillé de votre agence <img :src="'/images/flags/fr.png'" height="20px">
                        </template>
                    </v-textarea>

                    <v-textarea
                        class="textarea mt-5"
                        v-model="providerData.longDescriptionEn"
                        outlined>
                        <template v-slot:label>
                            Descriptif détaillé de votre agence <img :src="'/images/flags/en.png'" height="20px">
                        </template>
                    </v-textarea>
                </div>

                <div class="tabulation-title">
                    <h5>
                        <v-icon>label_outline</v-icon> Adresse administrative de votre agence
                    </h5>
                </div>

                <div class="form-container mr-auto ml-auto mt-5">
                    <v-text-field
                        class="mt-5"
                        label="Adresse"
                        v-model="providerData.localisation.address"
                        outlined>
                    </v-text-field>

                    <v-autocomplete
                        :items="communes"
                        class="mt-5"
                        label="Commune"
                        item-text="name"
                        v-model="providerData.localisation.commune"
                        return-object
                        :loading="loadingCommunes"
                        :search-input.sync="searchCommunes"
                        no-data-text="Saisissez pour sélectionner une ville"
                        outlined>
                    </v-autocomplete>

                    <v-text-field
                        label="Code postal"
                        class="mt-5"
                        v-model="providerData.localisation.postal_code"
                        outlined>
                    </v-text-field>
                </div>

                <div class="tabulation-title">
                    <h5>
                        <v-icon>label_outline</v-icon> Moyens de communication
                    </h5>
                </div>

                <div class="form-container mr-auto ml-auto mt-3">
                    <v-text-field
                        label="Site web"
                        class="mt-5"
                        v-model="providerData.website"
                        :class="{'input-error': checkUrlFormat(providerData.website) !== ''}"
                        outlined>
                    </v-text-field>

                    <div class="txt-error mt-1">
                        {{ checkUrlFormat(providerData.website) }}
                    </div>

                    <v-text-field
                        label="Url page Facebook"
                        class="mt-5"
                        v-model="providerData.facebook"
                        :class="{'input-error': checkUrlFormat(providerData.facebook) !== ''}"
                        outlined>
                    </v-text-field>

                    <div class="txt-error mt-1">
                        {{ checkUrlFormat(providerData.facebook) }}
                    </div>

                    <table class="mb-5 mt-5">
                        <tr>
                            <td>
                                <v-label>Site web en anglais</v-label>
                            </td>
                            <td>
                                <v-radio-group row class="mt-auto mb-auto ml-5" v-model="providerData.isWebsiteEnglish">
                                    <v-radio
                                        class="mr-5"
                                        label="Oui"
                                        :value="true"
                                        outlined>
                                    </v-radio>

                                    <v-radio
                                        label="Non"
                                        :value="false"
                                        outlined>
                                    </v-radio>
                                </v-radio-group>
                            </td>
                        </tr>
                    </table>

                    <div class="tabulation-title">
                        <h5 style="font-size: 15px">
                            <v-icon>label_outline</v-icon> Service Réceptif
                        </h5>
                    </div>

                    <v-text-field
                        class="mt-5"
                        label="Téléphone direct"
                        v-model="providerData.receptivePhone"
                        :class="{'input-error': checkPhoneFormat(providerData.receptivePhone) !== ''}"
                        outlined>
                    </v-text-field>

                    <div class="txt-error mt-1">
                        {{ checkPhoneFormat(providerData.receptivePhone) }}
                    </div>

                    <v-text-field
                        class="mt-5 mb-5"
                        label="E-mail direct"
                        v-model="providerData.receptiveEmail"
                        :class="{'input-error': checkEmailFormat(providerData.receptiveEmail) !== ''}"
                        outlined>
                    </v-text-field>

                    <div class="txt-error mt-1">
                        {{ checkEmailFormat(providerData.receptiveEmail) }}
                    </div>

                    <div class="tabulation-title">
                        <h5 style="font-size: 15px">
                            <v-icon>label_outline</v-icon> Contact grand public
                        </h5>
                    </div>

                    <v-text-field
                        label="Téléphone"
                        class="mt-5"
                        v-model="providerData.phone"
                        :class="{'input-error': checkPhoneFormat(providerData.phone) !== ''}"
                        outlined>
                    </v-text-field>

                    <div class="txt-error mt-1">
                        {{ checkPhoneFormat(providerData.phone) }}
                    </div>

                    <v-text-field
                        class="mt-5"
                        label="E-mail"
                        v-model="providerData.email"
                        :class="{'input-error': checkEmailFormat(providerData.email) !== ''}"
                        outlined>
                    </v-text-field>

                    <div class="txt-error mt-1">
                        {{ checkEmailFormat(providerData.email) }}
                    </div>
                </div>

                <aura-media :provider-data="providerData" :disabled="disabled"></aura-media>

                <div class="tabulation-title">
                    <h5>
                        <v-icon>label_outline</v-icon> Vos spécificités
                    </h5>
                </div>

                <div class="form-container mr-auto ml-auto mt-5">
                    <table>
                        <tr>
                            <td>
                                <v-label>
                                    Acceptez-vous de travailler avec des distributeurs ?
                                </v-label>

                                <v-tooltip slot="append-outer" bottom>
                                    <template v-slot:activator="{ on }">
                                        <v-icon v-on="on">help</v-icon>
                                    </template>
                                    <span>
                                        Il s'agit d'identifier une offre susceptible d'etre proposée par des réseaux <br>
                                        de distribution (T.O., agences de voyage), ou d'intéresser des comités <br>
                                        d'entreprise, ce qui implique qu'elle est impérativement commissionnable.
                                    </span>
                                </v-tooltip>
                            </td>
                            <td>
                                <v-radio-group row class="mt-auto mb-auto ml-5" v-model="providerData.acceptCooperation">
                                    <v-radio
                                        class="mr-5"
                                        label="Oui"
                                        :value="true"
                                        outlined>
                                    </v-radio>

                                    <v-radio
                                        label="Non"
                                        :value="false"
                                        outlined>
                                    </v-radio>
                                </v-radio-group>
                            </td>
                        </tr>
                    </table>

                    <v-autocomplete
                        :items="territories"
                        chips
                        v-model="providerData.territories"
                        deletable-chips
                        label="Territoire couvert"
                        class="mt-5"
                        item-text="label"
                        item-value="value"
                        multiple
                        outlined>
                    </v-autocomplete>

                    <v-autocomplete
                        :items="targetMarkets"
                        chips
                        v-model="providerData.targetMarkets"
                        deletable-chips
                        class="mt-5"
                        label="Marchés visés"
                        item-text="label"
                        item-value="value"
                        multiple
                        outlined>
                    </v-autocomplete>

                    <v-autocomplete
                        :items="customerTypes"
                        chips
                        v-model="providerData.customerTypes"
                        deletable-chips
                        class="mt-5"
                        label="Type de clientèle"
                        item-text="label"
                        item-value="value"
                        multiple
                        outlined>
                    </v-autocomplete>

                    <v-autocomplete
                        :items="thematicStays"
                        chips
                        v-model="providerData.thematicStays"
                        deletable-chips
                        class="mt-5"
                        label="Thématiques de séjours proposées par votre agence"
                        item-text="label"
                        item-value="value"
                        multiple
                        outlined>
                    </v-autocomplete>
                </div>

                <packaged-products :languages="languages" :disabled="disabled"></packaged-products>

                <div v-if="!disabled">
                    <div class="tabulation-title">
                        <h5>
                            <v-icon>label_outline</v-icon> Informations de la personne répondant
                        </h5>
                    </div>

                    <div class="panel form-container mr-auto ml-auto mt-5">
                        <div class="panel-heading">Vous êtes</div>
                        <div class="panel-body">
                            <v-text-field
                                v-model="providerData.contact.first_name"
                                label="Prénom"
                                class="mb-2"
                                autocomplete="new-first-name"
                                outlined>
                            </v-text-field>

                            <v-alert type="error" v-if="submitted &&
                                (providerData.contact.first_name === null || providerData.contact.first_name === '')">
                                Le prénom est requis.
                            </v-alert>

                            <v-text-field
                                v-model="providerData.contact.last_name"
                                label="Nom"
                                class="mb-2"
                                autocomplete="new-last-name"
                                outlined>
                            </v-text-field>

                            <v-alert type="error" v-if="submitted &&
                                (providerData.contact.last_name === null || providerData.contact.last_name === '')">
                                Le nom est requis.
                            </v-alert>

                            <v-text-field
                                v-model="providerData.contact.email"
                                label="E-mail"
                                autocomplete="new-email"
                                outlined>
                            </v-text-field>

                            <v-alert type="error" v-if="submitted &&
                                (providerData.contact.email === null || providerData.contact.email === '')">
                                Le mail est requis.
                            </v-alert>

                            <v-alert type="error" v-if="submitted && !isValidEmail && providerData.contact.email !== ''">
                                Le format du mail n'est pas bon.
                            </v-alert>
                        </div>
                    </div>
                </div>

                <v-alert color="rgb(209, 236, 241)" class="mt-4 form-container mr-auto ml-auto" v-if="!disabled">
                    <div class="d-flex cgu-box">
                        <div class="mt-auto mb-auto">
                            <v-checkbox v-model="acceptCgu"
                                        hide-details>
                            </v-checkbox>
                        </div>
                        <div>
                            <span>Le partenaire certifie que toutes les données le concernant recueillies par le
                              formulaire ci-dessous (descriptif, offres et photos) lui appartiennent et sont mis
                              à disposition d’Auvergne Rhône Alpes Tourisme, pour une mise à jour ou intégration
                              dans la base Apidae. Il reconnaît avoir pris connaissance des éléments ci-dessous : </span>
                            <ul>
                                <li>
                                    <a href="https://aide.apidae-tourisme.com/hc/fr/articles/360016788691-Conditions-d-adh%C3%A9sion-Apidae-pour-les-socio-professionnels-et-fournisseurs-d-informations" target="_blank">
                                        Conditions d'adhésion Apidae pour les socio-professionnels et fournisseurs d'informations
                                    </a>
                                </li>
                                <li>
                                    <a href="https://aide.apidae-tourisme.com/hc/fr/articles/360010422620--Suivi-de-la-mise-en-conformit%C3%A9-juridique-avec-vos-socio-pros-volets-RGPD-et-Droits-photos" target="_blank">
                                        Suivi de la mise en conformité juridique avec vos socio-pros - volets RGPD et Droits photos
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </v-alert>

                <div class="mt-5 mb-5 valid-button form-container mr-auto ml-auto"
                     v-if="providerData.localisation.commune === null || providerData.localisation.name === null">

                    <div class="title-valid-button">
                        <v-icon color="warning">warning</v-icon> Informations obligatoires
                    </div>

                    <div class="mt-3" v-if="providerData.name === null">
                        La nom de votre agence est requis.
                    </div>

                    <div class="mt-3" v-if="providerData.localisation.commune === null">
                        La commune de votre agence est requise.
                    </div>
                </div>

                <div class="form-container mr-auto ml-auto action-buttons form-container d-flex justify-content-between mt-5 mb-4 w-100" v-if="!disabled">
                    <v-btn color="primary"
                           @click="saveAnswer('ANSWERED')"
                           :disabled="!acceptCgu ||
                                      providerData.localisation.commune === null ||
                                      providerData.name === null">
                        <v-icon class="mr-3">check</v-icon> Valider mes informations
                    </v-btn>

                    <p class="mt-auto mb-auto"><b>OU</b></p>

                    <v-btn color="primary"
                           @click="saveAnswer('DRAFT')"
                           :disabled="!acceptCgu ||
                                      providerData.localisation.commune === null ||
                                      providerData.name === null">
                        <v-icon class="mr-3">save</v-icon> Enregistrer et revenir plus tard
                    </v-btn>
                </div>
            </div>
        </div>

        <div class="container p-5 mt-5 mb-5" v-if="displayThanks">
            <div class="logo">
                <v-img height="100px" position="center" contain :src="logo.doc_url"></v-img>
            </div>

            <div class="mt-5 text-center">
                <p>L’équipe d’Auvergne-Rhône-Alpes tourisme vous remercie pour vos précieuses réponses.</p>

                <p>Votre offre est à présent référencée dans Apidae Tourisme et seront en ligne sous peu sur notre site BtoB régional : <a href="https://www.inauvergnerhonealpes.com/" target="_blank">https://www.inauvergnerhonealpes.com/</a>.</p>

                <p>Nous restons à votre disposition,</p>

                <p>Irène Tronchet</p>
            </div>
        </div>

        <confirm ref="confirm" :hide-next="false"></confirm>
    </div>
</template>

<script>

import AuraMedia from "./AuraMedia"
import _ from "lodash"
import PackagedProducts from "@/components/aura/PackagedProducts"
import {mapMutations, mapState} from "vuex"
import * as EmailValidator from "email-validator"
import PhoneNumber from "awesome-phonenumber"
import Confirm from "../tools/Confirm"

export default {
    name: "AuraForm",
    components: {Confirm, PackagedProducts, AuraMedia},
    props: ['disabled', 'loadedProviderData'],
    data() {
        return {
            token: null,
            providerData: null,
            form: null,
            loaded: false,
            logo: null,
            organism: null,
            cgu: null,
            communes: [],
            loadingCommunes: false,
            searchCommunes: null,
            languages: [],
            languageValues: [],
            displayThanks: false,
            cguText: 'Les Conditions d\'utilisation ainsi que le Règlement sur le respect de la vie privée',
            submitted: false,
            acceptCgu: false,
            territories: [
                {
                    label: 'Ardèche & Drôme (vallée du Rhône)',
                    value: 6481
                },
                {
                    label: 'Auvergne',
                    value: 6478
                },
                {
                    label: 'Les Alpes (dont l\'Isère)',
                    value: 6479
                },
                {
                    label: 'Lyon et ses alentours (Vienne, Ain, Saint-Etienne, Beaujolais)',
                    value: 6480
                },
                {
                    label: 'Vallée de la Gastronomie',
                    value: 6482
                }
            ],
            targetMarkets: [
                {
                    label: 'France',
                    value: 20138
                },
                {
                    label: 'Europe',
                    value: 20139
                },
                {
                    label: 'Amériques',
                    value: 20140
                },
                {
                    label: 'Asie et Moyen Orient',
                    value: 20141
                },
                {
                    label: 'Autre',
                    value: 20142
                }
            ],
            customerTypes: [
                {
                    label: 'Individuel / FIT',
                    value: 5737
                },
                {
                    label: 'Groupe',
                    value: 593
                },
                {
                    label: 'Affaires / MICE',
                    value: 597
                }
            ],
            thematicStays: [
                {
                    label: 'Bien-être',
                    value: 20143
                },
                {
                    label: 'Ville et Culture',
                    value: 20144
                },
                {
                    label: 'Gastronomie & oenotourisme',
                    value: 20145
                },
                {
                    label: 'Neige / hiver',
                    value: 20146
                },
                {
                    label: 'Outdoor / itinérance',
                    value: 10147
                },
                {
                    label: 'Ecotourisme',
                    value: 20148
                }
            ]
        }
    },
    methods: {
        ...mapMutations('aura', ['setDefaultProduct', 'setProducts']),
        getForm() {
            this.$global.loading = true

            this.$http.get('aura/form/' + this.token).then(res => {
                this.providerData = res.body.data.providerData
                this.form         = res.body.data.form

                let config = res.body.data.config

                this.logo     = config.logo
                this.organism = config.organism
                this.cgu      = config.cgu

                if(this.providerData.localisation === null) {
                    this.providerData.localisation = {
                        address: null,
                        commune: null,
                        postal_code: null
                    }
                }

                if(this.providerData.target.length === 2) {
                    this.providerData.target = 6486
                } else if(this.providerData.target.length === 1) {
                    this.providerData.target = this.providerData.target[0]
                }

                if(this.providerData.localisation.commune !== undefined &&
                    this.providerData.localisation.commune !== null) {

                    this.communes.push(this.providerData.localisation.commune)
                    this.searchCommunes = this.providerData.localisation.commune.name
                }

                this.providerData.products = this.providerData.products.map(product => {
                    product.thematicStays    = product.thematicStays.map(elementId => {
                        return this.thematicStays.find(stay => stay.value === elementId)
                    })
                    product.customerTypes    = product.customerTypes.map(elementId => {
                        return this.customerTypes.find(customer => customer.value === elementId)
                    })
                    product.coverTerritories = product.coverTerritories.map(elementId => {
                        return this.territories.find(territory => territory.value === elementId)
                    })
                    product.languages        = product.languages.map(apidaeElementId => {
                        return this.languages.find(language => language.apidae_element_id === apidaeElementId)
                    })

                    return product
                })

                this.setProducts(this.providerData.products)

                this.$global.loading = false
                this.loaded          = true
            })
        },
        async getLanguages() {
            let res = await this.$http.get('resource/language-elts')

            this.languages = res.body.data.languages
        },
        getElementsByFamilyName(name) {
            return this.providerData.elements.filter(element => element.family.name === name)
                .map(element => element.apidae_element_id)
        },
        getCommunes: _.debounce(function() {
            this.loadingCommunes = true

            let payload = {
                search: this.searchCommunes
            }

            this.$http.post('resource/communes', payload).then(res => {
                this.communes = res.body.data.communes

                this.loadingCommunes = false
            })
        }, 500),
        saveAnswer(state) {
            this.submitted = true

            let validation = this.providerData.contact.email !== null && this.providerData.contact.email !== '' &&
                this.providerData.contact.first_name !== null && this.providerData.contact.first_name !== '' &&
                this.providerData.contact.last_name !== null && this.providerData.contact.last_name !== '' &&
                EmailValidator.validate(this.providerData.contact.email)

            if(validation) {
                if(state === 'ANSWERED') {
                    this.$refs.confirm.open('Confirmez vos informations',
                        'Après confirmation, vos informations vont être communiquées à ' +
                        'Auvergne Rhône-Alpes Tourisme et ne seront plus modifiables dans ce formulaire. Confirmez-vous l\'envoi ?',
                        { color: 'primary', backgroundTitle: 'primary' }).
                    then((confirm) => {
                        if (confirm) {
                            this.commitSave(state)
                        }
                    })
                } else {
                    this.commitSave(state)
                }
            }
        },
        commitSave(state) {
            this.providerData.products = this.products.map(product => {
                product.links            = product.links.filter(link => link.value !== null && link.value !== '')
                product.thematicStays    = product.thematicStays.map(element => element.value)
                product.customerTypes    = product.customerTypes.map(element => element.value)
                product.coverTerritories = product.coverTerritories.map(element => element.value)
                product.languages        = product.languages.map(element => element.apidae_element_id)

                return product
            })

            if(this.providerData.target === 6486) {
                this.providerData.target = [6484, 6485]
            } else if(!Array.isArray(this.providerData.target)) {
                this.providerData.target = [this.providerData.target]
            }

            let payload = {
                formId: this.form.id,
                providerData: this.providerData,
                state: state
            }

            this.$global.loading = true

            this.$http.post('aura/answer', payload).then(res => {
                this.submitted = true

                this.$global.loading = false

                if(state === 'ANSWERED') {
                    this.displayThanks = true
                } else {
                    this.$global.$emit('success-request', {
                        body: { message: 'Votre réponse a bien été enregistrée en brouillon. Vous devrez revenir plus tard pour la compléter et la valider.' }
                    })

                    this.getForm()
                }

                window.scrollTo(0, 0)
            })
        },
        checkPhoneFormat(phone) {
            let result = ''

            if(phone !== null) {
                let phoneFr = new PhoneNumber(phone, 'FR')
                let phoneNc = new PhoneNumber(phone, 'NC')
                let phoneCan = new PhoneNumber(phone, 'CA')

                result = (phoneFr.isValid() || phoneNc.isValid() || phoneCan.isValid()) ?
                  '' : 'Le format du téléphone n\'est pas correct'
            }

            return result
        },
        checkEmailFormat(email) {
            let result = ''

            if(email !== null) {
                let isValidEmail = EmailValidator.validate(email)
                result = isValidEmail ? '' : 'Le format de l\'email n\'est pas correct'
            }

            return result
        },
        checkUrlFormat(url) {
            let result = ''

            if(url !== null) {
                let isValidUrl = url.indexOf(' ') === -1
                result = isValidUrl ? '' : 'Le format de l\'URL n\'est pas correct'
            }

            return result
        },
        loadData() {
            this.providerData = this.loadedProviderData

            if(this.providerData.localisation.commune !== undefined &&
                this.providerData.localisation.commune !== null) {

                this.communes.push(this.providerData.localisation.commune)
                this.searchCommunes = this.providerData.localisation.commune.name
            }

            if(this.providerData.target.length === 2) {
                this.providerData.target = 6486
            } else if(this.providerData.target.length === 1) {
                this.providerData.target = this.providerData.target[0]
            }

            this.providerData.products = this.providerData.products.map(product => {
                product.thematicStays    = product.thematicStays.map(elementId => {
                    return this.thematicStays.find(stay => stay.value === elementId)
                })
                product.customerTypes    = product.customerTypes.map(elementId => {
                    return this.customerTypes.find(customer => customer.value === elementId)
                })
                product.coverTerritories = product.coverTerritories.map(elementId => {
                    return this.territories.find(territory => territory.value === elementId)
                })
                product.languages        = product.languages.map(apidaeElementId => {
                    return this.languages.find(language => language.apidae_element_id === apidaeElementId)
                })

                return product
            })

            this.setProducts(this.providerData.products)

            this.loaded = true
        }
    },
    computed: {
        ...mapState('aura', ['products']),
        isValidEmail() {
            return EmailValidator.validate(this.providerData.contact.email)
        }
    },
    watch: {
        searchCommunes() {
            this.searchCommunes = this.searchCommunes.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toUpperCase()

            this.getCommunes()
        }
    },
    async created() {
        window.Intercom('shutdown')
        window.Intercom('hide')

        this.setDefaultProduct()

        this.token = this.$route.params.token

        await this.getLanguages()

        if(this.loadedProviderData === undefined) {
            await this.getForm()
        } else {
            await this.loadData()
        }
    }
}
</script>

<style scoped>
    label {
        margin-top: auto;
        margin-bottom: auto;
    }

    .v-radio {
        min-width: 66px;
    }

    .v-input--selection-controls {
        margin: 0 !important;
    }

    .v-text-field:not(.v-textarea) .v-text-field__details {
        display: none !important;
    }

    .txt-error {
        font-size: 12px;
        color: red;
    }
</style>
